import type { ConversationPanelState, DockMode } from "./types";

const SHELL_TRANSITION_DURATION_MS = 280;
export const ANIMATION_TIMEOUT_MS = SHELL_TRANSITION_DURATION_MS + 80;

export const DOM_IDS = {
  shellBody: "circle-ai-shell-body",
  dockBody: "circle-ai-dock-body",
  conversationPanelBody: "circle-ai-conversation-panel-body",
  workspaceBody: "circle-ai-workspace-body",
  communityLeftSidebarBody: "circle-ai-left-sidebar-body",
  communityRightSidebarBody: "circle-ai-right-sidebar-body",
} as const;

export const LAYOUT_CONFIG = {
  dock: {
    cssVar: "--shell-dock-w",
    collapsed: 68,
    expanded: 220,
  },
  conversationPanel: {
    default: 400,
    minWidth: 320,
    maxWidth: 580,
  },
  communityLeftSidebar: {
    default: 320,
    minWidth: 280,
    maxWidth: 360,
  },
  communityRightSidebar: {
    default: 360,
    minWidth: 352,
    maxWidth: 720,
  },
  autoCollapseBreakpoint: 1440,
} as const;

const GRID_TEMPLATES: Record<ConversationPanelState, string> = {
  closed: "var(--shell-dock-w) 0px 1fr",
  default: `var(--shell-dock-w) ${LAYOUT_CONFIG.conversationPanel.default}px 1fr`,
  fullscreen: "var(--shell-dock-w) 1fr 0px",
};

export const resolveGridTemplate = (
  conversationPanelState: ConversationPanelState,
): string => GRID_TEMPLATES[conversationPanelState];

export const resolveShellVars = (
  dockMode: DockMode,
): Record<string, string> => ({
  [LAYOUT_CONFIG.dock.cssVar]:
    `${dockMode === "expanded" ? LAYOUT_CONFIG.dock.expanded : LAYOUT_CONFIG.dock.collapsed}px`,
});
